import { render, staticRenderFns } from "./sendFaxDialog.vue?vue&type=template&id=1e6fecca"
import script from "./sendFaxDialog.vue?vue&type=script&lang=js"
export * from "./sendFaxDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports